export function getCookie(name: string) {
  if (typeof document === 'undefined') return;

  const value = '; ' + document.cookie;
  const decodedValue = decodeURIComponent(value);
  const parts = decodedValue.split('; ' + name + '=');

  if (parts.length === 2) {
    return parts.pop()?.split(';').shift();
  }

  return null;
}

export const setCookie = (name: string, value: string, expiresIn: number) => {
  if (typeof document === 'undefined') return;
  const d = new Date();
  d.setTime(d.getTime() + expiresIn * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
};
